"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseFormInfoConfig = exports.modelInitialValues = exports.defaulInitialValues = exports.defaultFields = exports.defaultValidationSchemaConfig = void 0;
/** Validation schema :Yup structure */
exports.defaultValidationSchemaConfig = {
    email: {
        invalid: 'Invalid email',
        required: 'Field required'
    },
    phone: {
        invalid: 'Invalid phone number',
        required: 'Field required'
    },
    lastName: {
        invalid: 'Invalid last name',
        required: 'Field required',
        min: 'Last name must be at least 1 characters'
    },
    firstName: {
        invalid: 'Invalid first name',
        required: 'Field required',
        min: 'First name must be at least 1 characters'
    },
    comments: {
        min: 'Message must be at least 1 characters',
        max: 'Message must be at most 1000 characters'
    },
    modelName: {
        required: 'Please select valid model'
    },
    trim: {
        required: 'Please select valid trim'
    }
};
/** Field structure base on Dynamic Form */
exports.defaultFields = {
    firstName: {
        name: 'firstName',
        label: 'First Name',
        type: 'text',
        regex: /^[A-Za-z\ \'\-]{0,25}$/
    },
    lastName: {
        name: 'lastName',
        label: 'Last Name',
        type: 'text',
        regex: /^[A-Za-z\ \'\-]{0,25}$/
    },
    email: {
        name: 'email',
        label: 'Email',
        optionalLabel: 'Email (Optional)',
        type: 'email',
        regex: /^[\w@.-]*$/
    },
    phone: {
        name: 'phone',
        label: 'Phone',
        optionalLabel: 'Phone number (optional)',
        type: 'tel',
        regex: /^\d{0,10}$/im
    },
    preferredContactMethod: {
        name: 'preferredContactMethod',
        label: 'Preferred Contact',
        fields: [
            { value: 'email', label: 'Email' },
            { value: 'phone', label: 'Phone' },
            { value: 'either', label: 'Either' }
        ]
    },
    comments: {
        name: 'comments',
        label: '',
        placeholder: 'Add a message (Optional)',
        maxLenght: 1000
    },
    modelName: {
        name: 'modelName',
        label: 'Vehicle Model',
        placeholder: 'Select Model'
    },
    trim: {
        name: 'trim',
        label: 'Vehicle Trim',
        placeholder: 'Select Trim'
    }
};
/** Send schema with defined default values */
exports.defaulInitialValues = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    preferredContactMethod: 'email',
    comments: '',
};
exports.modelInitialValues = {
    modelName: '',
    trim: '',
};
/** General configuration and lenguage */
exports.baseFormInfoConfig = {
    formName: 'formName',
    formLabel: 'formLabel',
    submitLabel: 'Submit',
    legalDisclaimer: 'By clicking "SUBMIT," you accept our [Terms of Service](/en/terms.html) and [Privacy Statement](/en/privacy.html), you request that Volkswagen provide your personal information to our authorized dealers so that the dealers can contact you with marketing information, and you authorize Volkswagen and its dealers to contact you with marketing information, including by calling or texting you at the phone number(s) you\'ve provided. You understand these calls or texts may use computer-assisted dialing and/or prerecorded messages. This authorization is not required to complete the purchase or lease of any Volkswagen product. See Volkswagen of America\'s [Terms of Service](/en/terms.html) and [Privacy Statement](/en/privacy.html).'
};
